import { Panel } from '@/ui/atoms/panel/Panel'
import Image from 'next/image'
import { assets } from '@/ui/assets'
import { Typography } from '@/ui/atoms/typography/Typography'
import { Rank } from './Rank'

export function SeasonMewHero({ usePlaceholder }: { usePlaceholder: boolean }) {
  return (
    <Panel.Wrapper className="flex flex-col justify-between overflow-hidden sm:flex-row">
      <div className="flex-1">{usePlaceholder ? <HeroPlaceholder /> : <Rank />}</div>
      <div className="relative h-72 flex-1">
        <Image src={assets.seasonMewHero} alt="Season Mew Hero" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0E0E10] from-[5%] to-[15%] to-transparent" />
      </div>
    </Panel.Wrapper>
  )
}

function HeroPlaceholder() {
  return (
    <div className="flex h-full flex-col items-start justify-center gap-4 p-12">
      <Typography variant="h3" gradient className="text-xl">
        HypurrFi Points Season 1 Has Ended
      </Typography>
      <Typography variant="p">
        Next season’s HypurrFi Points are already being tracked. Get ready for a fresh new points experience coming very
        soon.
      </Typography>
    </div>
  )
}
